import { createFileRoute } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { OrderDetailContainer } from '@/components/screens/order-matching/order-detail-container'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_matching/$steel_order_id')({
  component: Page,
})

// route は機能フラグのガードとレイアウト（サイドバー + メイン領域）だけを組み、
// データ取得・ミューテーション配線は OrderDetailContainer に委譲する
// （order_matching/index.tsx の OrderMatchingContainer と同じ分担）
function Page() {
  const { tenant_id: tenantId, steel_order_id: steelOrderId } = Route.useParams()
  const me = useMe()

  // メニュー非表示でも URL 直打ちで到達できるため、画面側でも機能フラグを確認する
  // （一覧 route と同じガード。v1 route 末尾の Page ガードとも同じ）
  if (me.tenant.setting?.orderMatchingEnabled !== true) {
    return (
      <ErrorPanel
        title="発注照合機能が有効になっていません"
        description="ご利用のテナントでは発注照合機能が利用できません。利用をご希望の場合は運営までお問い合わせください。"
      />
    )
  }

  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />

      <main className="flex-1 overflow-x-hidden">
        <OrderDetailContainer tenantId={tenantId} steelOrderId={steelOrderId} />
      </main>
    </div>
  )
}
